export default __webpack_public_path__ + "104759cb32f420cdec7f77ea5cf81b9a.svg";